import React from "react"
import { Col, Row, Form } from "react-bootstrap"
import { getIn } from "formik"
import NumberFormat from "react-number-format"
import FormLabel from "./formLabel"

function FormAmountTextBox(props) {
  const { textDesc, form, field } = props

  const errorsMsg = getIn(form.errors, field.name)
  //const touched = getIn(form.touched, field.name)

  const inputErrorClassName = (touched, errors, inputName) => {
    // return (clickedNext && errors[inputName]) ||
    return errors[inputName] && touched[inputName] ? "is-invalid" : null
  }

  const inputErrorMessage = (touched, errors, inputName) => {
    // return (clickedNext && errors[inputName]) ||
    return errors[inputName] && touched[inputName] ? (
      <span className="InputError">{errorsMsg}</span>
    ) : null
  }

  return (
    <Form.Group>
      <Row>
        <FormLabel text={textDesc} />
        <Col xs={12} md={6} className="marginTop10px">
          <NumberFormat
            disabled={props.disabled}
            thousandSeparator=","
            decimalSeparator="."
            decimalScale={2}
            // thousandSeparator={true}
            // decimalSeparator={true}
            //format="#######.##"
            name={field.name}
            className={
              "inputbox text-right " +
              props.addClassName +
              " " +
              inputErrorClassName(form.touched, form.errors, field.name)
            }
            type="text"
            maxLength={14}
            autoComplete="new-password"
            value={field.value || ""}
            placeholder="0.00"
            onChange={form.handleChange}
            onBlur={form.handleBlur}
          />
          {/* {errors && touched && <span className="InputError">{errors}</span>} */}
          {inputErrorMessage(form.touched, form.errors, field.name)}
        </Col>
      </Row>
    </Form.Group>
  )
}
export default FormAmountTextBox
